import { createGlobalStyle } from "styled-components";
import { devices } from "../data/constants";


export const GlobalStyles = createGlobalStyle`

* {
  padding: 0;
  margin: 0;
  box-sizing: border-box;
}

body {
  margin: 0;
  background: ${({ theme }) => theme.colors.bgGradient};
  background-attachment: fixed;
  min-height: 100vh;
  font-family: ${({ theme }) => theme.colors.ff};
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
}

code {
  font-family: source-code-pro, Menlo, Monaco, Consolas, 'Courier New',
    monospace;
}

input[type=checkbox]
{
  /* Double-sized Checkboxes */
  -ms-transform: scale(1.5); /* IE */
  -moz-transform: scale(1.5); /* FF */
  -webkit-transform: scale(1.5); /* Safari and Chrome */
  -o-transform: scale(1.5); /* Opera */
  transform: scale(1.5);
  padding: 10px;
  @media only screen and ${devices.md} {
    -ms-transform: scale(1.25); /* IE */
    -moz-transform: scale(1.25); /* FF */
    -webkit-transform: scale(1.25); /* Safari and Chrome */
    -o-transform: scale(1.25); /* Opera */
    transform: scale(1.25);
  }
}



`